var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoAlternate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "253.89 130.94 334.06 334.06",
    style: {
      enableBackground: "new 0 0 841.89 595.28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#422916;}\n\t.st1{fill:#ffffff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "353.16,307.6 379.04,333.48 522.01,333.48 496.13,307.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "327.28,262.46 353.16,288.34 496.13,288.34 470.26,262.46  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    id: "path2",
    d: "M253.89,244.74L253.89,244.74c0,49.01,39.73,88.75,88.75,88.75h25.53l-24.58-24.58v-8.99v-9.99l-27.46-27.46 v-35.46h240.26v-71.02H342.64C293.62,155.99,253.89,195.72,253.89,244.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "path1",
    d: "M499.19,262.46h-17.78l25.88,25.88v19.54l25.85,25.85v35.2h-266.8v71.02h232.85 c49.01,0,88.75-39.73,88.75-88.75v0C587.94,302.2,548.21,262.46,499.19,262.46z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAlternate);
export default __webpack_public_path__ + "static/media/logoAlternate.61546c178de407b51122a61bd7b15a35.svg";
export { ForwardRef as ReactComponent };